module.exports = __webpack_public_path__ + "static/assets/dd8280d99397ca9e69b738220d6a4911.svg";